const translations = {
    headline: {
        type: 'text',
        defaultValue: 'Jakiego Kursu Szukasz?',
    },
    subheadline: {
        type: 'text',
        defaultValue: 'Znajdź kurs specjalnie dla siebie!',
    },
};

export default translations;
